var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "#989898",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16683 25.8332H22.8335V29.4998H8.16683V25.8332ZM8.16683 18.4998H22.8335V22.1665H8.16683V18.4998ZM19.1668 0.166504H4.50016C2.4835 0.166504 0.833496 1.8165 0.833496 3.83317V33.1665C0.833496 35.1832 2.46516 36.8332 4.48183 36.8332H26.5002C28.5168 36.8332 30.1668 35.1832 30.1668 33.1665V11.1665L19.1668 0.166504ZM26.5002 33.1665H4.50016V3.83317H17.3335V12.9998H26.5002V33.1665Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6c476f42.svg";
export { ForwardRef as ReactComponent };